// src/components/NavigationBar.js
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BsFillTelephoneFill } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import styles from "./styles.module.css";

function NavigationBar() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  const navLinkClass = ({ isActive }) =>
    isActive ? `${styles.linkStyle} ${styles.activeLink}` : styles.linkStyle;

  return (
    <nav className={styles.navStyle}>
      <div className={styles.navHeader}>
        <Link to="/" className={styles.logoLink}>
          <div className={styles.brandLogo}>
            <span className={styles.brandTitle}>Krushiratna</span>
          </div>
        </Link>
        <button
          type="button"
          className={styles.menuToggle}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          {menuOpen ? 'Close' : 'Menu'}
        </button>
      </div>
      <ul className={`${styles.ulStyle} ${menuOpen ? styles.open : ''}`}>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/" onClick={() => setMenuOpen(false)}>
            {t('Home')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/about" onClick={() => setMenuOpen(false)}>
            {t('About')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/contact" onClick={() => setMenuOpen(false)}>
            {t('Contact')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/products" onClick={() => setMenuOpen(false)}>
            {t('Products')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/enquiry" onClick={() => setMenuOpen(false)}>
            {t('Enquiry')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/careers" onClick={() => setMenuOpen(false)}>
            {t('Careers')}
          </NavLink>
        </li>
        <li className={styles.liStyle}>
          <NavLink className={navLinkClass} to="/vendersarea" onClick={() => setMenuOpen(false)}>
            {t('VendorsArea')}
          </NavLink>
        </li>
      </ul>
      <div className={styles.navActions}>
        <a href="tel:+917888160160" className={styles.phoneButton}>
          <BsFillTelephoneFill className={styles.iconStyle} />
          +91-7888160160
        </a>
        <div className={styles.languageSwitch}>
          <button className={styles.languageButton} onClick={() => changeLanguage('en')}>
            English
          </button>
          <button className={styles.languageButton} onClick={() => changeLanguage('mr')}>
            मराठी
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
